import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores';
import { ROUTES } from '@/constants';

/**
 * Dashboard index route handler — redirects every role to their landing page.
 * - Unassigned users → /dashboard/waiting
 * - Provider users   → /dashboard/providers
 * - Admin/staff      → /dashboard/providers (Providers page inside Outlet context)
 */
export function DashboardIndex() {
  const { isUnassigned, isProviderUser } = useAuthStore();

  if (isUnassigned()) {
    return <Navigate to={ROUTES.dashboardWaiting} replace />;
  }

  if (isProviderUser()) {
    return <Navigate to={ROUTES.dashboardProviders} replace />;
  }

  return <Navigate to={ROUTES.dashboardProviders} replace />;
}
